export default [
  {
    path: '/carrinho-compra',
    name: 'app-carrinho-compra',
    component: () => import('@/views/app/CartECommerce/carrinho-compra/Index.vue'),
    meta: {
      actions: 'CatalogoProdutos',
      resource: 'visualizar',
    },
  },
];
